import { PayloadAction } from "@reduxjs/toolkit";
import { ExportStatus, InitialState, VersionListType } from "./Types";

export const Reducer = {
  /**
   * To set the flag to show the dialog
   * @param state initial state value
   * @param action boolean values to set the flag
   */
  showDialog: (state: InitialState, action: PayloadAction<boolean>): void => {
    state.isToShowDialog = action.payload;
  },

  /**
   * To set the extract version
   * @param state initial state value
   * @param action Version list 
   */
  setVersionList: (state: InitialState, action: PayloadAction< VersionListType[]>): void => {
    state.versionList = action.payload;
  },

  /**
   * To set the export status
   * @param state initial state value
   * @param action Status 
   */
  setExportStatus: (state: InitialState, action: PayloadAction<ExportStatus>): void => {
    state.exportStatus = action.payload;
  },
};
